import { Checkbox, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";

import Context from "../../context";

export default function CredentialsCheckbox() {
	const { values } = useContext(Context);
	const { primaryColor, primaryTextColor, secondaryTextColor } = values;

	const isMobile = useResponsive("down", "sm");
	const { translate } = useLocales();

	return (
		<Stack maxWidth={320} flexDirection={"row"} alignItems={"center"} sx={{ mt: 2 }}>
			<Typography fontSize={12} variant='body1' alignItems={"center"} color={primaryTextColor}>
				<Checkbox
					name='storeCredentials'
					sx={{
						p: 0.4,
						mr: 1,
						mb: 0.2,
						color: secondaryTextColor,
						"&.Mui-checked": {
							color: primaryColor
						}
					}}
					size='small'
				/>
				{translate("connect_panel.save_credentials")}
			</Typography>
			{!isMobile && (
				<Iconify
					icon={"ci:info"}
					sx={{ ml: 1, mb: 0.1, cursor: "help" }}
					width={16}
					color={primaryColor}
				/>
			)}
		</Stack>
	);
}
